
<template>
	<c-dialog ref="dialog" mode="slide" width="100vw-300" mask-close @close="dialogFormEditConfirm($refs.qualityForm, arguments)" @resolve="submitHandle">
		<c-form ref="qualityForm" column="2" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="质检单编号">
					<c-input name="quality_code" placeholder="请输入，不填将自动生成"></c-input>
				</c-form-item>
				<c-form-item label="质检用户" required>
					<c-select name="test_user_id" async @search="searchUser" :value-data="userOptions" @change="changeUser"></c-select>
				</c-form-item>
				<c-form-item label="质检时间" required>
					<c-datetime name="test_date" type="datetime" format="yyyy-MM-dd hh:mm" time-accuracy="min"></c-datetime>
				</c-form-item>
				<c-form-item label="备注">
					<c-input type="textarea" name="remark"></c-input>
				</c-form-item>
				<c-form-item label="合格品自动入库" required>
					<c-radio-group name="fine_auto_in">
						<c-radio value="0">关闭</c-radio>
						<c-radio value="1">
							<div class="flex-center" style="gap: 5px">
								<span>开启</span>
								<c-tooltip tip="当工单最后一道工序『自动入库』状态为『关闭』时，开启有效"></c-tooltip>
							</div>
						</c-radio>
					</c-radio-group>
				</c-form-item>
				<!--自定义字段数据-->
				<custom-form ref="customForm" work-type="44"></custom-form>
			</c-form>

			<c-title>检验列表</c-title>
			<c-form-item :label="false" name="detail_list" colspan="3">
				<custom-table ref="detailTable" view-id="10017" work-type="46">
					<template #operate>
						<c-button color="main" prepend-icon="tf-add" @click="globalDialog('workSelector', {props: {'isWaitTest': true}}, detailSelectorHandle)">选择工单</c-button>
					</template>
					<!--产品来源-->
					<template #product_source="{data}">
						<c-state dict="productSourceName" :value="data.product_source"></c-state>
					</template>
					
					<!--产品类型-->
					<template #product_type="{data}">
						<c-state dict="productTypeName" :value="data.product_type"></c-state>
					</template>
					
					<!--质检数-->
					<template #test_count="{data}">
						<c-input name="test_count" type="number" decimal="2" :range="[0,data.wait_test_count]" v-model="data.test_count" :clear="false" @change="changeTestCount(data)"></c-input>
					</template>
					
					<!--质检合格数-->
					<template #test_fine_count="{data}">
						<c-input name="test_fine_count" type="number" decimal="2" :range="[0,data.test_count]" v-model="data.test_fine_count" :clear="false" @change="changeFineCount(data)"></c-input>
					</template>
					
					<!--质检不合格数-->
					<template #test_defects_count="{data}">
						<c-input type="number" decimal="2" :range="[0,data.test_count]" v-model="data.test_defects_count" :clear="false" @change="changeDefectsCount(data)"></c-input>
					</template>
					
					<!--质检良品率-->
					<template #test_fine_ratio="{data}">
						<span v-if="data.test_count == 0">-</span>
						<span v-else>{{parseFloat((data.test_fine_count*100/data.test_count).toFixed(6))}}%</span>
					</template>
					
					<!--说明备注-->
					<template #remark="{data}">
						<c-input v-model="data.remark" :clear="false"></c-input>
					</template>
					
					<c-table-column
                        type="button"
                        label="操作"
						width="160"
                    >
						<template #default="{data,remove}">
							<c-table-button v-if="(auth('b_quality_work_create') || auth('b_quality_work_edit')) && data.test_defects_count>0" icon="tf-edit" @click="editDefects(data)">{{data.test_defects_list.length?'修改':'填写'}}处理信息</c-table-button>
							<c-table-button v-if="(auth('b_quality_work_create') || auth('b_quality_work_edit'))" icon="tf-delete" @click="removeDetailRow(data,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
		
		<c-dialog ref="defectsEdit" title="不合格处理信息" width="900" height="600" enable-flex @resolve="editDefectsHandle">
			<c-form ref="defectsForm" column="1" vertical unit-width="100%">
				<c-form-item label="工单编号">
					<c-input name="work_code" disabled :clear="false"></c-input>
					<info-card 
						:info="[
								{name:'产品编号',value: detailRow.product_code},
								{name:'产品名称',value: detailRow.product_name},
								{name:'产品规格',value: detailRow.product_spec}
							]"
						:total="[
							{name:'质检总数',value: detailRow.test_count},
							{name:'质检合格数',value: detailRow.test_fine_count, color:'green'},
							{name:'质检不合格数',value: test_defects_count, color:'red'}
							]"
					></info-card>
				</c-form-item>
				<!-- <c-form-item label="质检不合格数">
					<c-input type="number" name="test_defects_count" decimal="6" disabled></c-input> 
				</c-form-item> -->
				<c-title >质检不合格处理信息</c-title>
				<c-form-item :label="false" name="test_defects_list" colspan="2">
					<m-operate border>
						<c-button color="main" prepend-icon="tf-add" @click="addRow()">添加一行</c-button>
					</m-operate>
					<c-table ref="test_defects_table" border :paging="false">
						<template #empty>
							<c-empty message="暂无质检不合格处理数据"></c-empty>
						</template>
						<c-table-column label="处理数量" width="110">
							<template #default="{data}">
								<c-input type="stepper" step-controls="side" decimal="6" :range="[0,test_defects_count]" v-model="data.test_defects_count"></c-input>
							</template>
						</c-table-column>
						<c-table-column label="处理方式" width="100" required>
							<template #default="{data}">
								<c-select name="after_type" :options="afterTypeDic" :clear="false" v-model="data.after_type" :disabled="(data.test_defects_count||0)<=0"></c-select>
							</template>
						</c-table-column>
						<c-table-column label="不合格原因" width="260">
							<template #default="{data}">
								<c-input v-model="data.defects_reasons" :disabled="(data.test_defects_count||0)<=0"></c-input>
							</template>
						</c-table-column>
						<c-table-column label="备注" width="150">
							<template #default="{data}">
								<c-input v-model="data.remark" :disabled="(data.test_defects_count||0)<=0"></c-input>
							</template>
						</c-table-column>
						<c-table-column label="发现日期" width="130">
							<template #default="{data}">
								<c-datetime v-model="data.discovery_date" type="date" format="yyyy-MM-dd" :disabled="(data.test_defects_count||0)<=0"></c-datetime>
							</template>
						</c-table-column>
						<c-table-column type="button" label="操作" width="70">
							<template #default="row">
								<c-table-button icon="tf-trash" @click="row.remove()">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
			</c-form>
		</c-dialog>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		computed: {
			// 获取dictName选项数据
			...mapState(['userInfo', 'afterTypeDic'])
		},
		
		data() {
			return {
				editState:false,
				quality_id:0,
				userOptions: [],
				deleteDetailList: [],
				test_defects_count: 0,
				work_id: 0,
				detailRow:{}
			}
		},

		methods: {
			open(data) {
				//初始化自定义字段控件
				this.$refs.customForm.init();
				//初始化产品列表控件
				this.$refs.detailTable.init();
				
				this.deleteDetailList = [];
				//清空表单数据
				this.$refs.qualityForm.clear();
				
				if (data) {
					this.quality_id = data.id;
					this.editState = true;
					this.getDetail();
				}else {
					this.quality_id = 0;
					this.$refs.qualityForm.set({
						fine_auto_in: 0,
						test_date: new Date().format('yyyy-MM-dd hh:mm')
					})
					
					//处理选中当前用户为检验用户信息
					this.userOptions = [{
						name: this.userInfo.user_realname,
						value: this.userInfo.id
					}];
				}
				this.$refs.dialog.open({
					title: data ? '编辑生产入库检验单' : '创建生产入库检验单'
				});
			},
			
			/*******搜索检验单详情*******************/
			getDetail() {
				this.request({
					url:'/quality/work/detail',
					data: {
						id: this.quality_id
					},
					loading: true,
					success: data => {
						
						//检验单基本信息
						this.$refs.qualityForm.set(data.detailInfo);
						//存在检验用户
						if(data.detailInfo.test_user_id){
							//处理选中检验用户信息
							this.userOptions = [{
								name: data.detailInfo.test_user_realname,
								value: data.detailInfo.test_user_id
							}];
						}
						data.detailList.forEach(item => {
							item.test_defects_list = item.test_defects_list||[]
						});
						
						//加载工单列表
						this.$refs.detailTable.$refs.list.setData(data.detailList);
					}
				});
			},

			changeUser({data}) {
				if (!data) return;
				this.$refs.customForm.setDefaultData({
					work_type_id: 45,
					source_list: [[{
						ref_work_type_id: 27,
						ref_id: data.id
					}]]
				});
			},
			
			/****行内数据变更事件-质检数**/
			changeTestCount(row){
				row.test_fine_count = 0;
				row.test_defects_count = 0;
				row.test_defects_list = [];
			},
			
			/****行内数据变更事件-合格数**/
			changeFineCount(row){
				row.test_defects_count = parseFloat(((row.test_count||0) - (row.test_fine_count||0)).toFixed(2));
			},
			
			/****行内数据变更事件-不合格数**/
			changeDefectsCount(row){
				row.test_fine_count = parseFloat(((row.test_count||0) - (row.test_defects_count||0)).toFixed(2));
			},

			/*******搜索【用户】下拉框信息*****************/
			searchUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/******选择明细响应方法*********/
			detailSelectorHandle(data) {
				
				//判断是否已存在于表格之中，已存在则不允许添加
				for (var i = 0; i < data.length; i++) {
					var newDetail = data[i];
				
					var existObj = this.$refs.detailTable.$refs.list.getData().find(function (obj) {
						return obj.ref_id == newDetail.id
					});
					if (existObj){
						this.$message({
							type:'warn',
							message:'工单【'+existObj.work_code+'】已存在，请勿重复添加',
						});
						return;
					}
				}
				
				//处理数据
				var detailList = data.map(item => {
					item.ref_id = item.id;
					item.id = null;
					item.test_count = item.wait_test_count||0;
					item.test_fine_count = 0;
					item.test_defects_count = 0;
					item.test_defects_list = [];
					item.remark=null;
					return item;
				});
				
				this.$refs.detailTable.$refs.list.push(detailList);
			},
			
			/******删除产品行数据********/
			removeDetailRow(data, remove) {
				if (data.id && data.id > 0){
					this.deleteDetailList.push(data.id);
				}
				remove();
			},
			
			/**编辑不合格处理信息*/
			editDefects(data){
				this.$refs.defectsEdit.open();
				this.test_defects_count = data.test_defects_count;
				this.detailRow = data;
				this.$refs.defectsForm.clear();
				this.$refs.defectsForm.set({
					work_code: data.work_code,
					test_defects_count: data.test_defects_count
				});
				this.work_id = data.ref_id;
				this.$refs.test_defects_table.setData(data.test_defects_list||[]);
			},
			
			/**编辑不合格处理信息回调*/
			editDefectsHandle(stop, next) {
				let test_defects_list = this.$refs.test_defects_table.getData();
				var total_test_defects_count = 0;
				if(test_defects_list==null || test_defects_list.length ==0){
					this.$message({
						message: '请至少添加一条不合格处理数据'
					});
					stop();
				}else{
					for (let i = 0; i < test_defects_list.length; i++) {
						const item = test_defects_list[i];
						if(!item.test_defects_count || (item.test_defects_count<=0)){
							this.$message({
								message: '请填写第' + (i+1) + '行不合格信息处理数量'
							});
							stop();
							return;
						}else if(!item.after_type){
							this.$message({
								message: '请选择第' + (i+1) + '行不合格信息处理方式'
							});
							stop();
							return;
						}else{
							total_test_defects_count = parseFloat(total_test_defects_count)+parseFloat(item.test_defects_count);
						}
					}
					
					if(total_test_defects_count != this.test_defects_count){
						this.$message({
							message: '处理数量总和应为'+this.test_defects_count+'，请检查'
						});
						stop();
					}else{
						this.detailRow.test_defects_list = test_defects_list;
					}
				}
				
			},
			
			/******添加行数据*********/
			addRow() {
				var rowData = {};
				rowData.discovery_date = new Date().format('yyyy-MM-dd')
				this.$refs.test_defects_table.push(rowData)
			},

			/*******提交编辑数据********************/
			submitHandle(stop, next) {
				stop();
				
				//工单列表
				var detail_list = this.$refs.detailTable.$refs.list.getData();
				
				this.$refs.qualityForm.submit({
					url: this.quality_id==0?'/quality/work/add':'/quality/work/edit',
					rule: {
						test_user_id:'请选择检测人',
						test_date:'请选择检测时间',
						detail_list: data => { 
							if(detail_list.length == 0){
								let msg = "请至少有一条质检数据信息";
								return msg;
							} 
							
							for (let i = 0; i < detail_list.length; i++) {
								const item = detail_list[i];
								if((item.test_count||0)==0){
									let msg = "第" + (i+1) + "行质检数不能为0";
									return msg;
								}else if((item.test_fine_count||0)==0 && (item.test_defects_count||0)==0 ){
									let msg = "第" + (i+1) + "行质检合格数、质检不合格数不能同时为0";
									return msg;
								}else if((item.test_defects_count||0)>0 && (item.test_defects_list==null || item.test_defects_list.length==0)){
									let msg = "请完善第" + (i+1) + "行不合格处理信息";
									return msg;
								}
							}
							//自定义字段校验
							return this.$refs.detailTable.validate();
						},
						...this.$refs.customForm.rule
					},
					dataFormatter: data => {
						data.id = this.quality_id||0;
						data.test_user_id = data.test_user_id||0;
						//明细列表
						data.detail_list = detail_list.map(item => {
							return {
								id: item.id,
								ref_type: 3,
								ref_id: item.ref_id,
								product_id: item.product_id,
								test_count: item.test_count,
								test_fine_count: item.test_fine_count||0,
								test_defects_count: item.test_defects_count||0,
								remark:item.remark,
								test_defects_list: item.test_defects_list,
								custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
							}
						});
						//被删除的任务ID列表
						data.delete_detail_list = this.deleteDetailList.map(item => {
							return {id:item}
						});
						//表单自定义字段
						data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
						return data;
					},
					success: () => {
						next();
						this.$message({
							type: 'success',
							message:this.editState ? '编辑生产入库检验单成功' : '创建生产入库检验单成功',
						});
						//刷新页面
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>